// Generated by purs version 0.14.4
var lift = function (dict) {
    return dict.lift;
};
export {
    lift
};
//# sourceMappingURL=index.js.map
